import { useGlobalContext } from "../context";
import { useParams } from "react-router-dom";
import Error from "./Error";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
// import { useTranslation } from "react-i18next";

const SingleRoom = () => {

  // const {t} = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 668px)' });

  const {rooms} = useGlobalContext();
  const {id} = useParams();

  const room = rooms.find(room => room.id === Number(id));
  if (!room) {
    return <Error />;
  }

  return (
    <Wrapper>
      <div className="container">
          <div className="row">
            <div className="col-12" style={isMobile ? {padding: '5px'} : {padding: '15px'}}>
               <h1>{room.name}</h1>
            </div>
          </div>
           <div className="row">
                {
                  room.images ?  (
                  room.images.map((image, index) => {
                    return <div key={index} className="col-12 col-md-4" style={isMobile ? {padding: '5px'} : {padding: '15px'}}>
                      <img src={image} alt="" />
                    </div>
                  })
                  ) : ''
                }
            </div>
      </div>
    </Wrapper>
  )
}

export default SingleRoom;


const Wrapper = styled.div`
  h1 {
    font-size: 30px;
  }
  padding-bottom: 40px;
  .col-12 {
    img {
      border-radius: 10px;
      width: 100%;
      display: block;
      object-fit: cover;
      object-position: center;
    }
  }
`
